let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("c0lrw")).then(() => parcelRequire('7QGXJ'));